import { useQuery } from "@apollo/client";
import ListTagsBySlugsQuery from "~/src/shared/graphql/ListTagsBySlugsQuery";
import {
  IListTagsBySlugsQuery,
  IListTagsBySlugsQueryVariables,
} from "~/src/shared/graphql/__generated__/ListTagsBySlugsQuery.generated";

interface IUseTagsFilter {
  tags: string[];
}
export default function useTagsFilter({ tags }: IUseTagsFilter) {
  const { data, loading } = useQuery<IListTagsBySlugsQuery, IListTagsBySlugsQueryVariables>(ListTagsBySlugsQuery, {
    variables: {
      slugs: tags,
    },
    skip: tags.length === 0,
  });

  return {
    tags: loading ? [] : data?.listTagsBySlugs.map(mapTagToFilterOption) || [],
    loading,
  };
}

function mapTagToFilterOption(tag: IListTagsBySlugsQuery["listTagsBySlugs"][0]) {
  return {
    value: tag.slug,
    name: tag.name,
  };
}
